/* eslint react/prop-types: 0, react/jsx-no-bind: 0, jsx-a11y/no-static-element-interactions: 0 */
import priceFormatter from 'currency-formatter'
import { AccessibleDivComponent } from 'svr/common/A11y'
import * as styles from '../assets/styles/eventOverview'
import QuantityStepper from '../containers/QuantityStepper'
import { connect } from 'react-redux'
import { calcTotalFeePrice } from '../utils/calcCharges'

priceFormatter.currencies[0].symbol = 'AED'
priceFormatter.currencies[0].symbolOnLeft = true

export const InventoryItemLarge = ({
  inventoryItem,
  inventoryEdits,
  selectInventoryItem,
  currencyCode,
  textMinimumSpend,
  isFeesInPriceDisplayed,
  defaultServiceCharge,
  availabilityId,
  remainingQuantity,
  shouldShowRemainingInventory,
}) => {
  const { price, compText, inventoryId, inventoryType, entryPerReservation } = inventoryItem
  const maxQuantity = Math.min(inventoryItem.maxQuantity, inventoryEdits[inventoryId].remainingQuantity)
  const quantity = Math.max(inventoryItem.minQuantity, inventoryEdits[inventoryId].quantity)
  const basePrice = price * quantity

  const totalFeePrice = calcTotalFeePrice(inventoryItem, quantity, price, defaultServiceCharge)
  const totalPrice = isFeesInPriceDisplayed ? basePrice + totalFeePrice : basePrice

  let headerText
  const numGuests = quantity * entryPerReservation

  const minDollarText = (function () {
    if (!inventoryItem.minPrice) {
      return ''
    }
    const minDollarAmount = quantity * inventoryItem.minPrice
    const minDollarAmountFormatted = priceFormatter.format(minDollarAmount, {
      code: currencyCode,
    })
    return `, ${minDollarAmountFormatted} ${textMinimumSpend}`
  })()

  if (numGuests === 1) {
    const headerInner = inventoryType === 'RESERVATION' ? `For 1 guest${minDollarText}` : 'For 1 guest'
    headerText = <span>{headerInner}</span>
  } else if (inventoryType === 'REQUEST') {
    headerText = <span />
  } else {
    let headerString
    if (inventoryType === 'RESERVATION') {
      headerString = `Up to ${numGuests} guests${minDollarText}`
    } else {
      headerString = `For ${numGuests} guests`
    }
    headerText = <span>{headerString}</span>
  }

  let priceText = priceFormatter.format(totalPrice, { code: currencyCode })
  if (inventoryType === 'GUESTLIST_TICKET_FREE') {
    priceText = compText
  } else if (inventoryType === 'REQUEST') {
    priceText = 'Request'
  }

  return (
    <div style={styles.inventoryListItem}>
      <div style={{ ...styles.tertiaryText, ...styles.textOverflow }} data-test="header-text">
        {headerText}
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ ...styles.primaryText, flex: '0 0 45%', marginTop: '10px' }}>{inventoryItem.inventoryName}</div>
        <div style={{ display: 'flex', flex: '0 0 55%', justifyContent: 'flex-end' }}>
          {maxQuantity > 1 && inventoryType !== 'REQUEST' && (
            <div style={{ flex: '1 1 auto' }}>
              <div>
                <QuantityStepper
                  inventoryId={inventoryId}
                  quantity={quantity}
                  minQuantity={inventoryItem.minQuantity}
                  maxQuantity={maxQuantity}
                />
              </div>
              {shouldShowRemainingInventory && <div style={styles.remainingQuantity}>{remainingQuantity} remaining</div>}
            </div>
          )}
          <div style={{ textAlign: 'right', margin: '10px 24px 0' }}>
            <div style={styles.secondaryText} data-test="price-text">
              {priceText}
            </div>
            {!!(isFeesInPriceDisplayed && totalFeePrice) && (
              <div data-test="fees-in-price" style={styles.tertiaryText}>
                * Includes {priceFormatter.format(totalFeePrice, { code: currencyCode })} in fees
              </div>
            )}
          </div>
          <AccessibleDivComponent
            aria-label="select event"
            style={{ ...styles.continueButton, flex: '0 0 auto' }}
            onClick={selectInventoryItem.bind(null, inventoryId, availabilityId)}
          >
            continue
          </AccessibleDivComponent>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = state => {
  const { date, eventId } = state.userSelection.toJS()

  return {
    eventAvailabilities: state.entities.availability.get(date).get(eventId),
    textMinimumSpend: state.widgetSettings.textMinimumSpend,
    shouldShowRemainingInventory: state.entities.events.get(eventId).get('shouldShowRemainingInventory'),
  }
}
const mergeProps = (stateProps, _dispatchProps, ownProps) => {
  const { inventoryId } = ownProps.inventoryItem
  const eventAvailabilities = stateProps.eventAvailabilities.get(inventoryId)

  return {
    ...stateProps,
    ...ownProps,
    availabilityId: eventAvailabilities.get('availabilityId'),
    remainingQuantity: eventAvailabilities.get('remainingQuantity'),
  }
}
export default connect(mapStateToProps, null, mergeProps)(InventoryItemLarge)
